import { load } from "@shopify/theme-sections";
import { qs } from "@fluorescent/dom";
import "focus-visible";
import "what-input";

import pageTransition from "@/lib/page-transition";
import quickAdd from "@/lib/quick-add";
import reviews from "@/lib/reviews";
import sectionClasses from "@/lib/section-classes";
import storeAvailabilityModal from "@/lib/store-availability-modal";
import modal from "@/lib/modal";
import viewportWatcher from "@/lib/viewport-watcher";

// Initialize lazysizes
import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/native-loading/ls.native-loading";
import lazySizes from "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";

// Import sections
import "@/sections";

lazySizes.cfg.nativeLoading = {
  setLoadingAttribute: true,
};

// Detect theme editor
if (window.Shopify.designMode === true) {
  document.documentElement.classList.add("theme-editor");
} else {
  const el = document.querySelector(".theme-editor-scroll-offset");
  el && el.parentNode.removeChild(el);
}

// Apply full-width classes
sectionClasses();

// Load all sections
document.addEventListener("DOMContentLoaded", () => {
  load("*");
});

// Page transitions
pageTransition();

// Setup modal
const modalElement = qs("[data-modal]", document);
modal(modalElement);

// Quick add to cart
quickAdd();

// Integrate with Shopify Product Reviews
reviews();

// Viewport width watcher
viewportWatcher();

// Product availabilty drawer
const availabilityModal = document.querySelector(
  "[data-store-availability-modal]"
);
storeAvailabilityModal(availabilityModal);

// Make it easy to see exactly what theme version
// this is by commit SHA
window.SHA = "__gitSHA";
